import { selectUsersState } from "redux/userPage/selectors/selectUsersState";
import { createSelector } from "reselect";

export const selectAllMinCompanies = createSelector([selectUsersState], (state) => state.allMinCompanies);
